/* eslint-disable no-undef */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import withMessages, { FormattedHTMLMessage } from 'component-utilities/intl';

import PrimaryButton from 'v-c/Buttons/PrimaryButton';
import SecondaryButton from 'v-c/Buttons/SecondaryButton';
import ModalCheckboxText from 'v-c/Modals/ModalCheckboxText';
import LargeCheckbox from 'v-c/Forms/Checkboxes/LargeCheckbox';

import {
  ModalContainer,
  ModalHeader,
  ModalContentLeft,
  ModalButtons,
  ModalText,
  ModalButtonSpacer,
} from '../Modals';

import { deleteSearchList } from '../../state_managers/SearchListsStateManager';
import { closeModal } from '../../state_managers/ModalsStateManager';

const BASE_KEY = 'app.dialog.delete_list';

type Props = {
  getMessage: Function,
  closeModal: Function,
  deleteSearchList: Function,
  modalOptions: {
    list: {
      id: string,
      name: string,
    },
  },
};

export function DeleteListModalComponent(props: Props) {
  const { getMessage, modalOptions: { list } } = props;
  const [isConfirmed, setIsConfirmed] = useState(false);

  const onClose = () => props.closeModal({ from: 'DeleteListModal/close' });
  const onDelete = () => {
    props.deleteSearchList(list.id);
    onClose();
  };

  return (
    <ModalContainer dataTags={{ 'data-modal': 'delete-list' }}>
      <ModalHeader withIcon type="warning" onCloseClick={onClose}>
        <FormattedHTMLMessage
          id={`${BASE_KEY}.message`}
          values={{ listName: list.name }}
        />
      </ModalHeader>
      <ModalContentLeft>
        <ModalText>{getMessage(`${BASE_KEY}.lower_section`)}</ModalText>
        <br />
        <br />
        <ModalText>
          <LargeCheckbox
            rawChildren
            checked={isConfirmed}
            onClick={() => setIsConfirmed(confirmed => !confirmed)}
          >
            <ModalCheckboxText>
              {getMessage(`${BASE_KEY}.confirm_message`)}
            </ModalCheckboxText>
          </LargeCheckbox>
        </ModalText>
      </ModalContentLeft>

      <ModalButtons>
        <PrimaryButton
          warning
          disabled={!isConfirmed}
          onClick={onDelete}
          data-action="confirm"
        >
          {getMessage('components.buttons.delete')}
        </PrimaryButton>
        <ModalButtonSpacer />
        <SecondaryButton onClick={onClose} data-action="dismiss">
          {getMessage('components.buttons.cancel')}
        </SecondaryButton>
      </ModalButtons>
    </ModalContainer>
  );
}

DeleteListModalComponent.propTypes = {
  getMessage: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  deleteSearchList: PropTypes.func.isRequired,
  modalOptions: PropTypes.shape({
    list: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  }).isRequired,
};

const DeleteListModal = connect(null, {
  closeModal,
  deleteSearchList,
})(withMessages(DeleteListModalComponent));

export default DeleteListModal;
